import { Observable } from 'rxjs/Observable';
import { ChangeLogService } from '../../core/services/change-log/changelog.service';
import { IStorage } from '../../core/services/storage/storage.interface';
import { ChangeQItem } from '../../core/services/sync-up/item';
import { IVasAppFacade } from '../services/vas-app-facade.service.interface';

export class ChangeLogFacade {

    protected service: ChangeLogService;

    constructor(
        protected appFacade: IVasAppFacade,
        protected storage: IStorage
    ) {
        this.service = new ChangeLogService(storage);
    }

    clear(): Promise<any> {
        return this.service.clear();
    }

    getCount(): Promise<number> {
        return this.service.getCount();
    }

    addItem(key: string, item: ChangeQItem): Promise<any> {
        return this.service.addItem(key, item);
    }

    enqueueItem(key: string, item: ChangeQItem): void {
        return this.service.enqueueItem(key, item);
    }

    updateItem(key: string, item: ChangeQItem): Promise<any> {
        return this.service.updateItem(key, item);
    }

    getItem(key: string): Promise<ChangeQItem> {
        return this.service.getItem(key);
    }

    getAllItems(): Promise<Array<ChangeQItem>> {
        return this.service.getAllItems();
    }

    getItemsById(id: string): Promise<Array<ChangeQItem>> {
        return this.service.getItemsById(id);
    }

    getItemsByParentId(id: string): Promise<Array<ChangeQItem>> {
        return this.service.getItemsByParentId(id);
    }

    keys(): Promise<Array<any>> {
        return this.service.keys();
    }

    removeItem(key: string): Promise<void> {
        return this.service.removeItem(key);
    }

    getChangesWaiting(): Observable<number> {
        return this.service.getChangesWaiting();
    }

    getKeysById(id: string): Array<string> {
        return this.service.getKeysById(id);
    }

    isChangePending(id: string): boolean {
        return this.service.isChangePending(id);
    }
}



// WEBPACK FOOTER //
// ./src/vas/facades/change-log-facade.ts